export default __webpack_public_path__ + "97b9b501e7758f42789f431a1d567861.png";